// extracted by mini-css-extract-plugin
module.exports = {"button":"Proposal_button__1WLfV","tabPanel":"Proposal_tabPanel__1eBWU","rotate":"Proposal_rotate__2hnxQ"};